import type { AxiosInstance } from 'axios'
import { getApiLink } from '@/utils/api-urls'
import createApiClient, { AXIOS_DEFAULT_OPTIONS } from '@/utils/create-api-client'
import { useWorkflow } from '@/composables/workflow/useWorkflow'

let notifierApiClient: AxiosInstance | undefined

const createNotifierApi = () => {
    const client = createApiClient(AXIOS_DEFAULT_OPTIONS)

    client.interceptors.request.use(request => {
        const { token, mode } = useWorkflow()

        request.baseURL = getApiLink('notifier', mode.value)
        // the gateway authorizes the header token, while workflow-notifier reads the token only from the query
        request.params = { ...request.params, token: token.value }

        return request
    })

    return client
}

export const useNotifierApi = () => {
    notifierApiClient ??= createNotifierApi()

    return notifierApiClient
}

// EventSource cannot send headers, so the stream authorizes with the query token only
export const notificationStreamUrl = () => {
    const { token, mode } = useWorkflow()

    return `${getApiLink('notifier', mode.value)}/stream?token=${encodeURIComponent(token.value ?? '')}`
}
